// extracted by mini-css-extract-plugin
module.exports = {"root":"_1wCEMgn","rootScrolled":"_1A3_vv9"};